module.exports = __webpack_public_path__ + "static/img/s4.ee333ac0.png";